import React from "react";
import { useFullScreenMaintenanceBanner } from "../hooks/useCMSData";
import { useMaintenanceBypass } from "../hooks/useMaintenanceBypass";
import { FullScreenMaintenance } from "./FullScreenMaintenance";

interface MaintenanceGateProps {
  children: React.ReactNode;
}

/**
 * Replaces the page with a maintenance takeover when a CMS banner flagged
 * `fullScreenMaintenance` targets the current path. Rendered above the router,
 * so the blocked page never mounts. While the banners file is loading the app
 * renders as normal — a takeover shouldn't gate every cold start on a fetch.
 *
 * Holding H + L bypasses the takeover for the rest of the session.
 */
export function MaintenanceGate({ children }: MaintenanceGateProps) {
  const banner = useFullScreenMaintenanceBanner();
  const bypassed = useMaintenanceBypass();

  if (banner && !bypassed) return <FullScreenMaintenance banner={banner} />;

  return <>{children}</>;
}
